var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailWheel3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FCBC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,31.3c-3.6-4.5-8.3-7-14.2-7.5c0-2.7,0-5.3,0-8.1c8.4,0.6,15.3,4.3,20.6,10.8c-0.1,0.1-0.1,0.2-0.2,0.3 C60,34.7,53.5,42.5,47.1,50.2c-1.7,2.1-5,1.7-6.2-0.7c-0.8-1.6-0.4-3.5,1-4.5c5.9-4.4,11.7-8.8,17.7-13.3 C59.9,31.6,60,31.5,60.2,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.5,29.1c1.5,2.5,2.6,5.1,3.2,7.8c1.9,8.5,0.3,16.3-4.8,23.3c-0.9,1.2-1.7,1.3-2.8,0.3 c-1.1-0.9-2.2-1.8-3.3-2.8c-0.9-0.8-1-1.5-0.3-2.5c3-4.1,4.3-8.6,3.8-13.7c-0.2-1.8-0.8-3.5-1.2-5.2c-0.1-0.4-0.1-0.7,0.2-1 C65,33.5,66.7,31.3,68.5,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,30.7C26.6,34,25,37.7,24.6,42c-2.7,0-5.4,0-8.1,0c0.4-6.5,2.8-12.1,7-17C25.6,27,27.4,28.8,29.4,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7,28.5c-1.9-1.9-3.8-3.8-5.7-5.7c4.8-4.3,10.5-6.6,17.1-7.1c0,2.7,0,5.3,0,8.1 C38.7,24.2,34.9,25.7,31.7,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,45.1c2.7,0,5.3,0,8,0c0.2,1,0.3,1.9,0.5,2.9c0.6,2.7,1.7,5.1,3.3,7.3c0.8,1.1,0.7,1.8-0.3,2.7 c-1.1,0.9-2.2,1.8-3.3,2.8c-1,0.8-1.8,0.7-2.6-0.3C18.8,56,17,51,16.6,45.4C16.6,45.3,16.6,45.3,16.6,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,63.2c4.4,0,8.8,0,13.3,0c0.9,0,1.4,0.4,1.6,1.1c0.2,1-0.4,1.8-1.4,1.9c-0.1,0-0.3,0-0.4,0 c-8.6,0-17.4,0-26,0c-1.1,0-1.8-0.5-1.8-1.4c0-0.9,0.5-1.5,1.4-1.6c1.3,0,2.6,0,4,0C38.3,63.2,41.4,63.2,44.5,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,70.3c6.5,0,13.2,0,19.7,0c1.4,0,2.1,0.4,2.4,1.1c0.3,1-0.5,1.8-2,1.9c-0.2,0-0.4,0-0.6,0 c-13,0-25.9,0-38.8,0c-1.7,0-2.6-0.5-2.7-1.4c-0.1-0.9,0.8-1.5,2.1-1.6c2,0,3.9,0,5.9,0C35.3,70.3,40,70.3,44.6,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,60.2c-1.8,0-3.5,0-5.3,0c-1.1,0-1.8-0.7-1.6-1.7c0.1-0.8,0.6-1.2,1.5-1.3c1.6,0,3.2,0,4.7,0 c2,0,4.1,0,6.1,0c1.2,0,1.9,1.3,1.3,2.3c-0.3,0.5-0.9,0.7-1.5,0.7C48,60.2,46.2,60.2,44.5,60.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailWheel3);
export default __webpack_public_path__ + "static/media/retail-wheel-3.9d9e90db5393477977cd9529162dd370.svg";
export { ForwardRef as ReactComponent };